/* Quilted Joy — Glide Free Thread Promo, cart page picker.
   Loaded once by sections/main-cart-items.liquid (outside .js-contents, so the
   tag survives Section Rendering re-renders). Uses document-level delegation
   because the picker markup is replaced via innerHTML on every cart change and
   inline scripts inserted that way never execute.

   Add flow: POST /cart/add.js with a Section Rendering `sections` list, then
   patch the same regions Dawn's cart.js patches, plus the (closed) cart drawer
   so it is fresh if opened later. Display only: the Dollarlabs function prices
   the cone at checkout. */

(function () {
  'use strict';
  if (window.qjGwpPickerInit) return;
  window.qjGwpPickerInit = true;

  function sectionInner(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function patch(targetRoot, selector, html) {
    if (html === null) return;
    var el = selector ? targetRoot.querySelector(selector) : targetRoot;
    if (el) el.innerHTML = html;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-qj-gwp-add]') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    btn.disabled = true;
    var originalLabel = btn.textContent;
    btn.textContent = 'Adding...';

    /* Shopify's bundled section rendering silently drops the whole `sections`
       payload when MORE THAN 5 ids are requested, so stay at exactly 5 and
       refresh the header price bubble with a separate GET afterwards. */
    var itemsEl = document.getElementById('main-cart-items');
    var footerEl = document.getElementById('main-cart-footer');
    var sectionIds = [];
    if (itemsEl && itemsEl.dataset.id) sectionIds.push(itemsEl.dataset.id);
    if (footerEl && footerEl.dataset.id) sectionIds.push(footerEl.dataset.id);
    ['cart-drawer', 'cart-icon-bubble', 'cart-icon-bubble1'].forEach(function (id) {
      sectionIds.push(id);
    });

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sectionIds.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (response) { return response.json(); })
      .then(function (state) {
        if (state.status && state.status !== 200) {
          throw new Error(state.description || state.message || 'Could not add to cart');
        }
        var sections = state.sections || {};

        if (itemsEl && sections[itemsEl.dataset.id]) {
          patch(itemsEl, '.js-contents', sectionInner(sections[itemsEl.dataset.id], '.js-contents'));
          var cartItemsEl = document.querySelector('cart-items');
          if (cartItemsEl) cartItemsEl.classList.remove('is-empty');
        }
        if (footerEl && sections[footerEl.dataset.id]) {
          patch(footerEl, '.js-contents', sectionInner(sections[footerEl.dataset.id], '.js-contents'));
          footerEl.classList.remove('is-empty');
        }
        if (sections['cart-drawer']) {
          var drawerEl = document.getElementById('CartDrawer');
          if (drawerEl) {
            patch(drawerEl, null, sectionInner(sections['cart-drawer'], '#CartDrawer'));
            var drawerWrap = document.querySelector('cart-drawer');
            if (drawerWrap) drawerWrap.classList.remove('is-empty');
          }
        }
        ['cart-icon-bubble', 'cart-icon-bubble1'].forEach(function (id) {
          var el = document.getElementById(id);
          if (el && sections[id]) {
            patch(el, '.shopify-section', sectionInner(sections[id], '.shopify-section'));
          }
        });

        /* 6th section, fetched separately because of the 5-section limit. */
        if (document.getElementById('cart-price-bubble')) {
          fetch('/?sections=cart-price-bubble')
            .then(function (r) { return r.json(); })
            .then(function (extra) {
              var el = document.getElementById('cart-price-bubble');
              if (el && extra['cart-price-bubble']) {
                patch(el, '.shopify-section', sectionInner(extra['cart-price-bubble'], '.shopify-section'));
              }
            })
            .catch(function () { /* cosmetic only */ });
        }

        /* The module itself re-rendered inside main-cart-items .js-contents,
           so the count and state are already fresh. Announce it and restore
           keyboard focus into the updated module. */
        var status = document.querySelector('[data-qj-gwp-status]');
        if (status) status.textContent = 'Thread added to your cart.';
        var module = document.querySelector('#main-cart-items [data-qj-gwp]');
        if (module) {
          var focusTarget = module.querySelector('[data-qj-gwp-add]') || module.querySelector('a');
          if (focusTarget) focusTarget.focus();
        }

        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'qj-gwp-thread' });
        }
      })
      .catch(function (err) {
        console.error('[qj-gwp-thread] add failed:', err);
        btn.disabled = false;
        btn.textContent = originalLabel;
        var status = document.querySelector('[data-qj-gwp-status]');
        if (status) status.textContent = 'Sorry, that color could not be added. Please try again.';
      });
  });
})();
